var $2b6e161c9edcf319$exports = {};
const $2b6e161c9edcf319$var$addGlass = document.querySelector(".add--glass--js");
const $2b6e161c9edcf319$var$deleteGlass = document.querySelector(".delete--glass--js");
const $2b6e161c9edcf319$var$counter = document.querySelector(".counter--js");
let $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
let $2b6e161c9edcf319$var$numberOfGlasses = 0;
setInterval(()=>{
    if ($2b6e161c9edcf319$var$key !== new Date().toLocaleString().slice(0, 10)) {
        $2b6e161c9edcf319$var$key = new Date().toLocaleString().slice(0, 10);
        $2b6e161c9edcf319$var$numberOfGlasses = 0;
        $2b6e161c9edcf319$var$counter.innerHTML = $2b6e161c9edcf319$var$numberOfGlasses;
        localStorage.setItem($2b6e161c9edcf319$var$key, 0);
    }
}, 60000);
let $2b6e161c9edcf319$var$checkGlasses = localStorage.getItem($2b6e161c9edcf319$var$key);
console.log($2b6e161c9edcf319$var$checkGlasses);
if ($2b6e161c9edcf319$var$checkGlasses === null) localStorage.setItem($2b6e161c9edcf319$var$key, 0);
else $2b6e161c9edcf319$var$numberOfGlasses = parseInt($2b6e161c9edcf319$var$checkGlasses);
$2b6e161c9edcf319$var$counter.innerHTML = $2b6e161c9edcf319$var$numberOfGlasses;
$2b6e161c9edcf319$var$addGlass.addEventListener("click", function() {
    $2b6e161c9edcf319$var$numberOfGlasses += 1;
    $2b6e161c9edcf319$var$counter.innerHTML = $2b6e161c9edcf319$var$numberOfGlasses;
    localStorage.setItem($2b6e161c9edcf319$var$key, $2b6e161c9edcf319$var$numberOfGlasses);
});
$2b6e161c9edcf319$var$deleteGlass.addEventListener("click", function() {
    if ($2b6e161c9edcf319$var$numberOfGlasses > 0) $2b6e161c9edcf319$var$numberOfGlasses -= 1;
    $2b6e161c9edcf319$var$counter.innerHTML = $2b6e161c9edcf319$var$numberOfGlasses;
    localStorage.setItem($2b6e161c9edcf319$var$key, $2b6e161c9edcf319$var$numberOfGlasses);
});


//# sourceMappingURL=index.f10b39a9.js.map
